import React from 'react';
import PropTypes from 'prop-types';

import {updateENVFn, clickListenerFn} from './applicationFn.js';
import {mainRenderFn} from './mainRenderFn.js';

class Searchelector extends React.Component {
  constructor(props) {
    super(props);
    this.env = {};
    this.searchStatusArr = new Array();
    this.printoutData = {};
    this.optionsActive = false;

    this.__clickListenerFn = this._clickListenerFn.bind(this);
  }
  componentWillMount () {
    this._updateENVFn(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this._updateENVFn(nextProps);
  }
  render () {
    return mainRenderFn(this);
  }

  _updateENVFn (nextProps) {
    updateENVFn(this, nextProps);
  }
  _clickListenerFn (event) {
    clickListenerFn(this, event);
  }
}

Searchelector.propTypes = {
  selectorId    : PropTypes.string.isRequired,
  optionHeadArr : PropTypes.array.isRequired,
  optionBodyArr : PropTypes.array.isRequired
};
Searchelector.defaultProps = {
  selectorId    : 'btbSelect',
  optionHeadArr : [],
  optionBodyArr : []
};

export default Searchelector;
